import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { ICustomer } from "@app/common";

interface CustomerDeleteModalProps extends ModalInstance<ICustomer>, Omit<DeleteModalProps<ICustomer>, 'children'> {
  onDelete: (customer: Partial<ICustomer>) => void;
}

export const CustomerDeleteModal = (props: CustomerDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer un client.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
} 